export default function CorrectFilled(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
			<path
				d="M7.0037 0C3.13908 0 0 3.13908 0 7.0037C0 10.8683 3.13908 14.0074 7.0037 14.0074C10.8683 14.0074 14.0074 10.8683 14.0074 7.0037C14.0074 3.13908 10.8609 0 7.0037 0ZM10.8683 4.99736L6.48546 9.9799C6.34479 10.1428 6.13749 10.2316 5.92279 10.2316H5.90799C5.68588 10.2316 5.48599 10.128 5.34532 9.95769L3.11687 7.23321C2.85775 6.91486 2.90217 6.44844 3.22052 6.18191C3.53887 5.92279 4.00529 5.96721 4.27181 6.28556L5.945 8.32893L9.7504 4.00529C10.0243 3.69434 10.4907 3.66473 10.8017 3.93866C11.1126 4.21259 11.1423 4.67901 10.8683 4.98995V4.99736Z"
				fill="currentColor"
			/>
		</svg>
	);
}
